<div class="tile">
  @if (badge) {
    <ion-badge class="badge" color="danger">{{ badge }}</ion-badge>
  }

  @if (isPreview) {
    <ion-badge class="preview" color="warning">
      <ion-icon name="construct" size="small"></ion-icon>
    </ion-badge>
  }

  @if (isDynamic) {
    <ion-badge class="dynamic" color="light">
      <ion-icon name="information-outline" size="small"></ion-icon>
    </ion-badge>
  }

  @if (isURL) {
    <ion-badge class="dynamic" color="light">
      <ion-icon name="globe-outline" size="small"></ion-icon>
    </ion-badge>
  }

  @if (tile.ionBadgeIcon) {
    <ion-badge class="badge" [class]="tile.ionBadgeIconClass" [color]="tile.ionBadgeColor">
      <ion-icon [name]="tile.ionBadgeIcon"></ion-icon>
    </ion-badge>
  }
  @if (isDynamic) {
    <img class="icon" [src]="icon" draggable="false" />
    <span class="title">{{ tile | localizedString: 'name' }}</span>
  } @else {
    @if(missingIcon) {
      <ion-icon name="warning-outline" class="xlarge"></ion-icon>
    } @else {
      <img class="icon" [src]="iconPath()" draggable="false" (error)="handleImageError($event)" />
    }
    <span class="title">{{ titleTranslateKey() | translate }}</span>
  }
</div>
